import { useMemo } from "react";
import ConfirmedOrderItem from "./ConfirmedOrderItem"
import DeliveredOrderItem from "./DeliveredOrderItem"
import FinishedOrderItem from "./FinishedOrderItem"
import ForConfirmOrderItem from "./ForConfirmOrderItem"

function OrdersList({ orders, setLoading, boxes, searchTerm, setSearchTerm }: any) {
  // Filtra las terminadas según el searchTerm
  const finishedOrders = useMemo(
    () =>
      orders.filter(
        (o: any) =>
          o.state === "finished" &&
          (!searchTerm ||
            o.customer?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            o.id?.toString().includes(searchTerm))
      ),
    [orders, searchTerm]
  );

  const deliveredOrders = useMemo(
    () =>
      orders.filter(
        (o: any) =>
          o.state === "delivered" &&
          (!searchTerm ||
            o.customer?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            o.id?.toString().includes(searchTerm))
      ),
    [orders, searchTerm]
  );

  return (
    <div className='d-flex flex-column mt-2'>
      {/* Barra de búsqueda solo si hay terminadas */}
      {orders.some((o: any) => o.state === "finished" || o.state === "delivered") && (
        <input
          type="text"
          className="form-control mb-2"
          placeholder="Buscar orden terminada..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
      )}
      {orders.map((o: any, i: number) => {
        if (o.state === 'created') {
          return <ForConfirmOrderItem order={o} key={i} />
        }
        if (o.state === 'confirmed') {
          return <ConfirmedOrderItem order={o} setLoading={setLoading} key={i} />
        }
        if (o.state === 'delivered') {
          // Solo mostrar las entregadas que pasan el filtro
          if (
            !searchTerm ||
            deliveredOrders.find((do_: any) => do_.id === o.id)
          ) {
            return <DeliveredOrderItem order={o} key={i} boxes={boxes} />
          }
          return null;
        }
        if (o.state === "finished") {
          // Solo mostrar las terminadas que pasan el filtro
          if (
            !searchTerm ||
            finishedOrders.find((fo: any) => fo.id === o.id)
          ) {
            return <FinishedOrderItem order={o} key={i} />
          }
          return null;
        }
        return null
      })}
    </div>
  )
}

export default OrdersList